import { AllocationRuleTemplateFormView } from '@host/pages/AllocationRulesTemplatePageView/AllocationRulesTemplatePageView'
import { CheckinContainerPage } from '@host/pages/CheckinContainer/CheckinContainerPage'
import { ContainerJourneyHistoryPage } from '@host/pages/ContainerJourneyHistoryPage/ContainerJourneyHistoryPage'
import { ContainerMasterDataWrapper } from '@host/pages/ContainerMasterData/ContainerMasterDataWrapper'
import { ContainerTurnovers } from '@host/pages/ContainerTurnovers/ContainerTurnovers'
import { Dashboard } from '@host/pages/Dashboard/Dashboard'
import DGSettingsPage from '@host/pages/DGSettings/DGSettingsPage'
import { CraneSplitPage } from '@host/pages/EquipmentPlanning/CraneSplitPage'
import { GateInFormDialogWrapper } from '@host/pages/GateControl/components/GateInDialogWrapper'
import { GeneralCargoOperator } from '@host/pages/GeneralCargoOperator/GeneralCargoOperator'
import {
  GeneralCargoOrderFormRoutePage,
  GeneralCargoOrdersPage,
} from '@host/pages/GeneralCargoOrders/GeneralCargoOrdersPage'
import { AddHoldTypeWrapper, HoldTypesListWrapper } from '@host/pages/HoldTypes/HoldTypesWrapper'
import { IsoCodeMappingWrapper } from '@host/pages/IsoCodeMapping/IsoCodeMappingWrapper'
import { Issue } from '@host/pages/Issues/Issue'
import { MasterData } from '@host/pages/MasterData/MasterData'
import { NNROrderControlWrapper } from '@host/pages/NNROrders/NNROrderControlWrapper'
import { withNumericReleaseSetup } from '@host/pages/NumericReleases/withNumericReleaseSetup'
import { CreateOrderPageWrapper } from '@host/pages/Orders/CreateOrderPageWrapper'
import { EditOrdersPageWrapper } from '@host/pages/Orders/EditOrdersPageWrapper'
import { OrdersPageWrapper } from '@host/pages/Orders/OrdersPageWrapper'
import { RailVisitDetails } from '@host/pages/RailVisit/RailVisitDetails'
import { ReeferMonitoringPage } from '@host/pages/ReeferMonitoring/ReeferMonitoringPage'
import { ServiceOrdersPage } from '@host/pages/ServiceOrders/ServiceOrdersPage'
import { TenantConfigurationPage } from '@host/pages/TenantConfiguration/TenantConfiguration'
import { TenantCreationPage } from '@host/pages/Tenants/Tenants'
import { TruckVisitsPage } from '@host/pages/TruckVisits/TruckVisitsPage'
import { UpdateContainerByOperator } from '@host/pages/UpdateContainerByOperator/UpdateContainerByOperator'
import { VesselVisitDischargeList } from '@host/pages/VesslVisit/VesselVisitDischargeList'
import { VesselVisitLoadList } from '@host/pages/VesslVisit/VesselVisitLoadList'
import { VesselVisitRestowList } from '@host/pages/VesslVisit/VesselVisitRestowList'
import { VesselVisitTPR } from '@host/pages/VesslVisit/VesselVisitTPR'
import { YardClerk } from '@host/pages/YardClerk/YardClerk'
import { YardView } from '@host/pages/YardView/YardView'
import {
  ArchetypeControlPage,
  ArchetypeListPage,
  DamageCatalogue,
  RoleFormPage,
  RolesPage,
  Tenants,
  UserFormPage,
  UsersTablePage,
} from '@tom-ui/admin'
import { CommoditiesAndPackaging, CommodityFormPage, Companies, Reports } from '@tom-ui/billing'
import {
  CraneOperatorItemView,
  CraneOperatorLanding,
  CraneOperatorListView,
  CraneOperatorNoGeometryView,
  Equipment,
  EquipmentPlanning,
  EquipmentPlanningRail,
  GangFormPage,
  GangPage,
  HatchCoverMoveItemPage,
  HatchCoverMovesPage,
  OperationalEquipmentFormPage,
  OperationalEquipmentPage,
  ReeferOperator,
  ShiftFormPage,
  ShiftPage,
  StoppageFormPage,
  StoppageReason,
  StoppageReasonFormPage,
  StoppagesPage,
  WorkInstructionsControlRoom,
} from '@tom-ui/operations'
import {
  AddEmptyRailcarPage,
  BookingsPage,
  CheckoutContainerPage,
  ContainerHistoryPage,
  ContainerJourneyReportPage,
  ContainerMasterDataPage,
  ContainersReport,
  ExternalDriverFormPage,
  ExternalDriverPage,
  HoldsPage,
  LocationCodesPage,
  MasterLocationCodesPage,
  NonNumericReleasesDetailsPage,
  NonNumericReleasesPage,
  NumericReleaseFormControlPage,
  NumericReleasesDetailsPage,
  NumericReleasesPage,
  RailcarsPage,
  RailVisitBulkEditPage,
  RailVisitPage,
  RailVisitPlanningPage,
  VesselBookingsPage,
  VesselPage,
  VesselServicePage,
  VesselVisitBulkEditPage,
  VesselVisitPlanningPage,
  VesselVisitsPage,
  VisitsPage,
} from '@tom-ui/planning'
import { OrdersList as OrdersList2 } from '@tom-ui/planning/pages/Order/components/Organisms'
import {
  Berths,
  GeneralCargoAreas,
  GeneralCargoInventory,
  GlobalAllocationRules,
  AllocationRuleTemplatesPage as OldAllocationRuleTemplatesPage,
  ContainerTurnovers as OldContainerTurnovers,
  YardSetup as OldYardSetup,
  OperatorContainerTurnoversList,
  Piers,
  RailTracksPage,
  StowageInstructionFormPage,
  StowageInstructionPage,
  WeightClassesPage,
  YardInconsistencies,
  YardManagement,
  YardPlanningDashboard,
  YardPlanningDashboardDetails,
  YardPlanningIssues,
} from '@tom-ui/storage'
import { PATHS } from '@tom-ui/utils'
import {
  AllocationRulesTemplatePage,
  ContainerLengthBayMappingsPage,
  PierFormPage,
  PiersPage,
} from '@tom-ui/yard'
import Permission from 'modules/utils/src/utils/permission.enum'
import { ComponentType } from 'react'
import { CSVUploadWrapper } from '../pages/CSVUpload/CSVUploadWrapper'
import { EquipmentOperator } from '../pages/EquipmentOperator/EquipmentOperator'
import { GateClerkPage } from '../pages/GateClerk/GateClerkPage'
import Arcade from '../pages/Profile/Arcade'
import DocumentationStatus from '../pages/Profile/DocumentationStatus/DocumentationStatus'
import { ContainerPinballPage } from '../pages/Profile/ContainerPinballPage'
import { DonkeyStackerPage } from '../pages/Profile/DonkeyStackerPage'
import { InventoryDronePage } from '../pages/Profile/InventoryDronePage'
import { PortDefensePage } from '../pages/Profile/PortDefensePage'
import Profile from '../pages/Profile/Profile'
import { ReachStackerRunnerPage } from '../pages/Profile/ReachStackerRunnerPage'
import { TerminalCrossingPage } from '../pages/Profile/TerminalCrossingPage'
import { YardHaulPage } from '../pages/Profile/YardHaulPage'
import { VesselInvadersPage } from '../pages/Profile/VesselInvadersPage'
import { YardPacmanPage } from '../pages/Profile/YardPacmanPage'
import ResetDemo from '../pages/Reset/Reset'
import { TallyclerkPage } from '../pages/TallymanV2/TallyclerkPage'
import { VesselVisitDetails } from '../pages/VesslVisit/VesselVisitDetails'

export type RequiredFeatureFlag = {
  name: string
  enable: boolean
}

export interface RouteProps {
  path: string
  component: ComponentType
  requiredPermission?: Permission
  requiredFeatureFlag?: RequiredFeatureFlag
  hidden?: boolean
}

interface Props {
  skipCraneSplit: boolean
  showUnifiedOperatorPage: boolean
  skipVesselTally: boolean
  skipRailTally: boolean
  hasGeneralCargo: boolean
  hasDamageCatalogue: boolean
  skipYardPlanning: boolean
  vesselBookings: boolean
  isNewYardEnabled: boolean
}

export const routes = ({
  skipCraneSplit,
  showUnifiedOperatorPage,
  skipVesselTally,
  skipRailTally,
  hasGeneralCargo,
  hasDamageCatalogue,
  skipYardPlanning,
  vesselBookings,
  isNewYardEnabled,
}: Props): RouteProps[] => [
  {
    path: PATHS.dashboard.url,
    component: Dashboard,
  },
  {
    path: PATHS.profile.url,
    component: Profile,
  },
  {
    path: PATHS.portDefense.url,
    component: PortDefensePage,
  },
  {
    path: PATHS.reachStackerRunner.url,
    component: ReachStackerRunnerPage,
  },
  {
    path: PATHS.yardHaul.url,
    component: YardHaulPage,
  },
  {
    path: PATHS.yardPacman.url,
    component: YardPacmanPage,
  },
  {
    path: PATHS.vesselInvaders.url,
    component: VesselInvadersPage,
  },
  {
    path: PATHS.containerPinball.url,
    component: ContainerPinballPage,
  },
  {
    path: PATHS.donkeyStacker.url,
    component: DonkeyStackerPage,
  },
  {
    path: PATHS.terminalCrossing.url,
    component: TerminalCrossingPage,
  },
  {
    path: PATHS.inventoryDrone.url,
    component: InventoryDronePage,
  },
  {
    path: PATHS.arcade.url,
    component: Arcade,
  },
  {
    path: PATHS.documentationStatus.url,
    component: DocumentationStatus,
  },
  {
    path: PATHS.masterData.url,
    component: MasterData,
    requiredPermission: PATHS.masterData.permission,
  },
  {
    path: PATHS.config.reset.url,
    component: ResetDemo,
    requiredPermission: PATHS.config.reset.permission,
  },
  {
    path: PATHS.config.csvUpload.url,
    component: CSVUploadWrapper,
  },
  {
    path: PATHS.masterData.vessels.url,
    component: VesselPage,
    requiredPermission: PATHS.masterData.vessels.permission,
  },
  {
    path: PATHS.masterData.containers.url,
    component: ContainerMasterDataPage,
    requiredPermission: PATHS.masterData.containers.permission,
  },
  {
    path: `${PATHS.masterData.containers.url}/new`,
    component: ContainerMasterDataWrapper,
    requiredPermission: PATHS.masterData.containers.permission,
  },
  {
    path: `${PATHS.masterData.containers.url}/:id`,
    component: ContainerMasterDataWrapper,
    requiredPermission: PATHS.masterData.containers.permission,
  },
  {
    path: `${PATHS.masterData.containers.url}/:id/${PATHS.masterData.containers.history.url}`,
    component: ContainerHistoryPage,
    requiredPermission: PATHS.masterData.containers.history.permission,
    requiredFeatureFlag: { name: 'container-history', enable: true },
  },
  {
    path: `${PATHS.masterData.containers.url}/:id/${PATHS.masterData.containers.history.url}/:turnoverId`,
    component: ContainerJourneyHistoryPage,
    requiredPermission: PATHS.masterData.containers.history.permission,
    requiredFeatureFlag: { name: 'container-history', enable: true },
  },
  {
    path: PATHS.masterData.railcars.url,
    component: RailcarsPage,
    requiredPermission: PATHS.masterData.railcars.permission,
  },
  {
    path: PATHS.masterData.locationCodes.url,
    component: LocationCodesPage,
    requiredPermission: PATHS.masterData.locationCodes.permission,
  },
  {
    path: PATHS.masterData.masterLocationCodes.url,
    component: MasterLocationCodesPage,
    requiredPermission: PATHS.masterData.masterLocationCodes.permission,
  },
  {
    path: PATHS.masterData.archetypes.url,
    component: ArchetypeListPage,
    requiredPermission: PATHS.masterData.archetypes.permission,
  },
  {
    path: `${PATHS.masterData.archetypes.url}/new`,
    component: ArchetypeControlPage,
    requiredPermission: PATHS.masterData.archetypes.permission,
  },
  {
    path: `${PATHS.masterData.archetypes.url}/:id`,
    component: ArchetypeControlPage,
    requiredPermission: PATHS.masterData.archetypes.permission,
  },
  {
    path: PATHS.masterData.isoCodeMappings.url,
    component: IsoCodeMappingWrapper,
    requiredPermission: PATHS.masterData.isoCodeMappings.permission,
  },
  {
    path: PATHS.controlRoom.reeferMonitoring.url,
    component: ReeferMonitoringPage,
  },
  {
    path: PATHS.reports.url,
    component: Reports,
    requiredPermission: PATHS.reports.permission,
  },
  {
    path: PATHS.masterData.companies.url,
    component: Companies,
    requiredPermission: PATHS.masterData.companies.permission,
  },
  {
    path: PATHS.masterData.stoppageReason.url,
    component: StoppageReason,
    requiredPermission: PATHS.masterData.stoppageReason.permission,
  },
  {
    path: `${PATHS.masterData.stoppageReason.url}/new`,
    component: StoppageReasonFormPage,
    requiredPermission: PATHS.masterData.stoppageReason.permission,
  },
  {
    path: `${PATHS.masterData.stoppageReason.url}/:id`,
    component: StoppageReasonFormPage,
    requiredPermission: PATHS.masterData.stoppageReason.permission,
  },
  {
    path: PATHS.config.users.url,
    component: UsersTablePage,
    requiredPermission: PATHS.config.users.permission,
  },
  {
    path: `${PATHS.config.users.url}/new`,
    component: UserFormPage,
    requiredPermission: PATHS.config.users.permission,
  },
  {
    path: `${PATHS.config.users.url}/:id`,
    component: UserFormPage,
    requiredPermission: PATHS.config.users.permission,
  },
  {
    path: PATHS.config.roles.url,
    component: RolesPage,
    requiredPermission: PATHS.config.roles.permission,
  },
  {
    path: `${PATHS.config.roles.url}/new`,
    component: RoleFormPage,
    requiredPermission: PATHS.config.roles.permission,
  },
  {
    path: `${PATHS.config.roles.url}/:id`,
    component: RoleFormPage,
    requiredPermission: PATHS.config.roles.permission,
  },
  {
    path: PATHS.masterData.externalDrivers.url,
    component: ExternalDriverPage,
    requiredPermission: PATHS.masterData.externalDrivers.permission,
  },
  {
    path: PATHS.masterData.externalDriversForm.url,
    component: ExternalDriverFormPage,
    requiredPermission: PATHS.masterData.externalDriversForm.permission,
  },
  {
    path: PATHS.config.tenants.url,
    component: Tenants,
    requiredPermission: PATHS.config.tenants.permission,
  },
  {
    path: `${PATHS.config.tenants.url}/:id`,
    component: TenantCreationPage,
    requiredPermission: PATHS.config.tenants.permission,
  },
  {
    path: `${PATHS.config.tenants.url}/new`,
    component: TenantCreationPage,
    requiredPermission: PATHS.config.tenants.permission,
  },
  {
    path: PATHS.config.tenantConfiguration.url,
    component: TenantConfigurationPage,
    requiredPermission: PATHS.config.tenantConfiguration.permission,
  },
  {
    path: PATHS.visits.vesselVisits.url,
    component: VesselVisitsPage,
    requiredPermission: PATHS.visits.vesselVisits.permission,
  },
  {
    path: PATHS.visits.visits.url,
    component: VisitsPage,
    requiredPermission: PATHS.visits.visits.permission,
  },
  {
    path: PATHS.orders.bookings.url,
    component: vesselBookings ? VesselBookingsPage : BookingsPage,
    requiredPermission: PATHS.orders.bookings.permission,
  },
  {
    path: `${PATHS.orders.bookings.url}/:bookingNumber/${PATHS.orders.bookings.visit.url}/:visitId/orders`,
    component: OrdersList2,
    requiredPermission: PATHS.orders.bookings.visit.permission,
  },
  {
    path: `${PATHS.orders.bookings.url}/:bookingNumber/${PATHS.orders.bookings.visit.url}/:visitId/orders/:orderId`,
    component: EditOrdersPageWrapper,
    requiredPermission: PATHS.orders.bookings.visit.permission,
  },
  {
    path: PATHS.visits.railVisits.url,
    component: RailVisitPage,
    requiredPermission: PATHS.visits.railVisits.permission,
  },
  {
    path: `${PATHS.visits.railVisits.url}/:id`,
    component: RailVisitDetails,
    requiredPermission: PATHS.visits.railVisits.permission,
  },
  {
    path: `${PATHS.visits.railVisits.url}/:visitId/:direction/${PATHS.visits.railVisits.order.url}/new`,
    component: CreateOrderPageWrapper,
    requiredPermission: PATHS.visits.railVisits.order.permission,
  },
  {
    path: `${PATHS.visits.railVisits.url}/:visitId/:direction/${PATHS.visits.railVisits.order.url}/:orderId`,
    component: EditOrdersPageWrapper,
    requiredPermission: PATHS.visits.railVisits.order.permission,
  },
  {
    path: `${PATHS.visits.railVisits.url}/:id/:direction/bulk-edit`,
    component: RailVisitBulkEditPage,
    requiredPermission: PATHS.visits.railVisits.order.permission,
    requiredFeatureFlag: { name: 'rail-bulk-edit', enable: true },
  },
  {
    path: `${PATHS.visits.railVisits.url}/:id/${PATHS.visits.railVisits.checkin.url}/:orderId`,
    component: CheckinContainerPage,
    requiredPermission: PATHS.visits.railVisits.checkin.permission,
  },
  {
    path: `${PATHS.visits.railVisits.url}/:id/${PATHS.visits.railVisits.checkout.url}/:orderId`,
    component: CheckoutContainerPage,
    requiredPermission: PATHS.visits.railVisits.checkout.permission,
  },
  {
    path: `${PATHS.visits.railVisits.url}/:id/:page`,
    component: RailVisitDetails,
    requiredPermission: PATHS.visits.railVisits.permission,
  },
  {
    path: `${PATHS.visits.railVisits.url}/:visitId/:direction/railcar/new`,
    component: AddEmptyRailcarPage,
    requiredPermission: PATHS.visits.railVisits.permission,
  },
  {
    path: PATHS.visits.truckVisits.url,
    component: TruckVisitsPage,
    requiredPermission: PATHS.visits.truckVisits.permission,
  },
  {
    path: `${PATHS.visits.truckVisits.url}/${PATHS.visits.truckVisits.new.url}`,
    component: GateInFormDialogWrapper,
    requiredPermission: PATHS.visits.truckVisits.new.permission,
  },
  {
    path: `${PATHS.visits.truckVisits.url}/:id`,
    component: GateInFormDialogWrapper,
    requiredPermission: PATHS.visits.truckVisits.permission,
  },
  {
    path: PATHS.orders.serviceOrders.url,
    component: ServiceOrdersPage,
    requiredPermission: PATHS.orders.serviceOrders.permission,
  },
  {
    path: `${PATHS.visits.containerVisits.url}/${PATHS.visits.containerVisits.order.url}/new`,
    component: CreateOrderPageWrapper,
    requiredPermission: PATHS.visits.containerVisits.order.permission,
  },
  {
    path: `${PATHS.visits.containerVisits.url}/${PATHS.visits.containerVisits.order.url}/:orderId`,
    component: EditOrdersPageWrapper,
    requiredPermission: PATHS.visits.containerVisits.order.permission,
  },
  {
    path: `${PATHS.visits.containerVisits.url}/:containerNumber?`,
    component: OrdersPageWrapper,
    requiredPermission: PATHS.visits.containerVisits.permission,
  },
  {
    path: `${PATHS.visits.containerVisits.url}/:id/${PATHS.visits.containerVisits.checkin.url}/:orderId`,
    component: CheckinContainerPage,
    requiredPermission: PATHS.visits.containerVisits.checkin.permission,
  },
  {
    path: `${PATHS.visits.containerVisits.url}/:id/${PATHS.visits.containerVisits.checkout.url}/:orderId`,
    component: CheckoutContainerPage,
    requiredPermission: PATHS.visits.containerVisits.checkout.permission,
  },
  {
    path: PATHS.operators.yardclerk.url,
    component: YardClerk,
    requiredPermission: PATHS.operators.yardclerk.permission,
  },
  {
    path: PATHS.operators.tallyclerk.url,
    component: TallyclerkPage,
    requiredPermission: PATHS.operators.tallyclerk.permission,
    hidden: skipVesselTally && skipRailTally,
  },
  {
    path: PATHS.operators.gateClerk.url,
    component: GateClerkPage,
    requiredPermission: PATHS.operators.gateClerk.permission,
  },
  {
    path: PATHS.orders.numericReleases.url,
    component: withNumericReleaseSetup(NumericReleasesPage),
    requiredPermission: PATHS.orders.numericReleases.permission,
  },
  {
    path: `${PATHS.orders.numericReleases.url}/new`,
    component: withNumericReleaseSetup(NumericReleaseFormControlPage),
    requiredPermission: PATHS.orders.numericReleases.permission,
  },
  {
    path: `${PATHS.orders.numericReleases.url}/:numericReleaseId`,
    component: withNumericReleaseSetup(NumericReleaseFormControlPage),
    requiredPermission: PATHS.orders.numericReleases.permission,
  },
  {
    path: `${PATHS.orders.numericReleases.url}/:numericReleaseId/details`,
    component: withNumericReleaseSetup(NumericReleasesDetailsPage),
    requiredPermission: PATHS.orders.numericReleases.permission,
  },
  {
    path: PATHS.orders.nonNumericReleases.url,
    component: NonNumericReleasesPage,
    requiredPermission: PATHS.orders.nonNumericReleases.permission,
  },
  {
    path: `${PATHS.orders.nonNumericReleases.url}/new`,
    component: NNROrderControlWrapper,
    requiredPermission: PATHS.orders.nonNumericReleases.permission,
  },
  {
    path: `${PATHS.orders.nonNumericReleases.url}/:nnrOrderId`,
    component: NNROrderControlWrapper,
    requiredPermission: PATHS.orders.nonNumericReleases.permission,
  },
  {
    path: `${PATHS.orders.nonNumericReleases.url}/:nnrOrderId/details`,
    component: NonNumericReleasesDetailsPage,
    requiredPermission: PATHS.orders.nonNumericReleases.permission,
  },
  {
    path: `${PATHS.orders.nnrForVisit.url}/:vesselVisitId`,
    component: NonNumericReleasesPage,
    requiredPermission: PATHS.orders.nnrForVisit.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/:direction/nnr-orders/assign-container/:nnrOrderId`,
    component: NonNumericReleasesDetailsPage,
    requiredPermission: PATHS.visits.vesselVisits.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.equipments.url}`,
    component: EquipmentPlanning,
    requiredPermission: PATHS.visits.vesselVisits.equipments.permission,
    hidden: skipCraneSplit,
  },
  {
    path: `${PATHS.visits.railVisits.url}/:id/${PATHS.visits.railVisits.equipments.url}`,
    component: EquipmentPlanningRail,
    requiredPermission: PATHS.visits.railVisits.equipments.permission,
    hidden: skipCraneSplit,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.kpi.url}`,
    component: VesselVisitTPR,
    requiredPermission: PATHS.visits.vesselVisits.kpi.permission,
    hidden: skipCraneSplit,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.craneSplit.url}`,
    component: CraneSplitPage,
    requiredPermission: PATHS.visits.vesselVisits.craneSplit.permission,
    hidden: skipCraneSplit,
  },
  {
    path: PATHS.controlRoom.jobs.url,
    component: WorkInstructionsControlRoom,
    requiredPermission: PATHS.controlRoom.jobs.permission,
  },
  {
    path: PATHS.operators.crane.url,
    component: CraneOperatorLanding,
    requiredPermission: PATHS.operators.crane.permission,
  },
  {
    path: `${PATHS.operators.crane.url}/${PATHS.operators.crane.bayView.url}/List/:vesselVisitId/:equipmentId`,
    component: CraneOperatorListView,
    requiredPermission: PATHS.operators.crane.bayView.permission,
    hidden: showUnifiedOperatorPage,
  },
  {
    path: `${PATHS.operators.crane.url}/${PATHS.operators.crane.bayView.url}/Item/:vesselVisitId/:equipmentId/:bay/:operationType`,
    component: CraneOperatorItemView,
    requiredPermission: PATHS.operators.crane.bayView.permission,
    hidden: showUnifiedOperatorPage,
  },
  {
    path: `${PATHS.operators.crane.url}/${PATHS.operators.crane.noGeometryView.url}/:vesselVisitId/:equipmentId`,
    component: CraneOperatorNoGeometryView,
    requiredPermission: PATHS.operators.crane.noGeometryView.permission,
    hidden: showUnifiedOperatorPage,
  },
  {
    path: PATHS.operators.generalCargo.url,
    component: GeneralCargoOperator,
    requiredPermission: PATHS.operators.generalCargo.permission,
    hidden: !hasGeneralCargo,
  },
  {
    path: PATHS.operators.reeferOperator.url,
    component: ReeferOperator,
    requiredPermission: PATHS.operators.reeferOperator.permission,
  },
  {
    path: `${PATHS.operators.operator.url}/:page`,
    component: EquipmentOperator,
    requiredPermission: PATHS.operators.operator.permission,
  },
  {
    path: PATHS.controlRoom.equipments.url,
    component: Equipment,
    requiredPermission: PATHS.controlRoom.equipments.permission,
  },
  {
    path: PATHS.controlRoom.operationalEquipment.url,
    component: OperationalEquipmentPage,
    requiredPermission: PATHS.controlRoom.operationalEquipment.permission,
  },
  {
    path: `${PATHS.controlRoom.operationalEquipment.url}/:ids`,
    component: OperationalEquipmentFormPage,
    requiredPermission: PATHS.controlRoom.operationalEquipment.permission,
  },
  {
    path: PATHS.masterData.shift.url,
    component: ShiftPage,
    requiredPermission: PATHS.masterData.shift.permission,
  },
  {
    path: `${PATHS.masterData.shift.url}/:id`,
    component: ShiftFormPage,
    requiredPermission: PATHS.masterData.shift.permission,
  },
  {
    path: PATHS.masterData.gang.url,
    component: GangPage,
    requiredPermission: PATHS.masterData.gang.permission,
  },
  {
    path: `${PATHS.masterData.gang.url}/:id`,
    component: GangFormPage,
    requiredPermission: PATHS.masterData.gang.permission,
  },
  {
    path: PATHS.masterData.stowageInstruction.url,
    component: StowageInstructionPage,
    requiredPermission: PATHS.masterData.stowageInstruction.permission,
  },
  {
    path: `${PATHS.masterData.stowageInstruction.url}/:id`,
    component: StowageInstructionFormPage,
    requiredPermission: PATHS.masterData.stowageInstruction.permission,
  },
  {
    path: PATHS.visits.vesselPlanning.url,
    component: VesselVisitPlanningPage,
    requiredPermission: PATHS.visits.vesselPlanning.permission,
  },
  {
    path: `${PATHS.visits.vesselPlanning.url}/:id`,
    component: VesselVisitPlanningPage,
    requiredPermission: PATHS.visits.vesselPlanning.permission,
  },
  {
    path: `${PATHS.visits.railPlanning.url}`,
    component: RailVisitPlanningPage,
    requiredPermission: PATHS.visits.railPlanning.permission,
  },
  {
    path: `${PATHS.visits.railPlanning.url}/:id`,
    component: RailVisitPlanningPage,
    requiredPermission: PATHS.visits.railPlanning.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id`,
    component: VesselVisitDetails,
    requiredPermission: PATHS.visits.vesselVisits.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:visitId/:direction/${PATHS.visits.vesselVisits.order.url}/new`,
    component: CreateOrderPageWrapper,
    requiredPermission: PATHS.visits.vesselVisits.order.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:visitId/:direction/${PATHS.visits.vesselVisits.order.url}/:orderId`,
    component: EditOrdersPageWrapper,
    requiredPermission: PATHS.visits.vesselVisits.order.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.hatchCovers.url}`,
    component: HatchCoverMovesPage,
    requiredPermission: PATHS.visits.vesselVisits.hatchCovers.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.hatchCovers.url}/:hatchcoverid/Upsert`,
    component: HatchCoverMoveItemPage,
    requiredPermission: PATHS.visits.vesselVisits.hatchCovers.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.stoppages.url}`,
    component: StoppagesPage,
    requiredPermission: PATHS.visits.vesselVisits.stoppages.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.stoppages.url}/new`,
    component: StoppageFormPage,
    requiredPermission: PATHS.visits.vesselVisits.stoppages.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.stoppages.url}/:stoppageId`,
    component: StoppageFormPage,
    requiredPermission: PATHS.visits.vesselVisits.stoppages.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.load.url}`,
    component: VesselVisitLoadList,
    requiredPermission: PATHS.visits.vesselVisits.load.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.discharge.url}`,
    component: VesselVisitDischargeList,
    requiredPermission: PATHS.visits.vesselVisits.discharge.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/:direction/bulk-edit`,
    component: VesselVisitBulkEditPage,
    requiredPermission: PATHS.visits.vesselVisits.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/${PATHS.visits.vesselVisits.restow.url}`,
    component: VesselVisitRestowList,
    requiredPermission: PATHS.visits.vesselVisits.restow.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/:page`,
    component: VesselVisitDetails,
    requiredPermission: PATHS.visits.vesselVisits.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/checkin/:orderId`,
    component: CheckinContainerPage,
    requiredPermission: PATHS.visits.vesselVisits.permission,
  },
  {
    path: `${PATHS.visits.vesselVisits.url}/:id/checkout/:orderId`,
    component: CheckoutContainerPage,
    requiredPermission: PATHS.visits.vesselVisits.permission,
  },
  {
    path: PATHS.issues.issues.url,
    component: Issue,
    requiredPermission: PATHS.issues.issues.permission,
  },
  {
    path: PATHS.issues.holds.url,
    component: HoldsPage,
    // TODO: requiredPermission: PATHS.issues.issues.permission,
  },
  {
    path: PATHS.generalCargo.orders.url,
    component: GeneralCargoOrdersPage,
    hidden: !hasGeneralCargo,
  },
  {
    path: `${PATHS.generalCargo.orders.url}/new`,
    component: GeneralCargoOrderFormRoutePage,
    hidden: !hasGeneralCargo,
  },
  {
    path: `${PATHS.generalCargo.orders.url}/:id`,
    component: GeneralCargoOrderFormRoutePage,
    hidden: !hasGeneralCargo,
  },
  {
    path: PATHS.yard.management.url,
    component: YardManagement,
    requiredPermission: PATHS.yard.permission,
  },
  {
    path: PATHS.config.yardSetup.url,
    component: isNewYardEnabled ? YardView : OldYardSetup,
    requiredPermission: PATHS.config.yardSetup.permission,
  },
  {
    path: PATHS.yard.view.url,
    component: YardView,
    requiredPermission: PATHS.yard.permission,
  },
  {
    path: PATHS.yard.containerTurnovers.url,
    component: isNewYardEnabled ? ContainerTurnovers : OldContainerTurnovers,
  },
  {
    path: PATHS.yard.planningIssues.url,
    component: YardPlanningIssues,
  },
  {
    path: PATHS.yard.inconsistencies.url,
    component: YardInconsistencies,
  },
  {
    path: PATHS.yard.planningDashboard.url,
    component: YardPlanningDashboard,
  },
  {
    path: `${PATHS.yard.planningDashboard.url}/:vesselVisitId/:handlingDirection/:discriminator`,
    component: YardPlanningDashboardDetails,
  },
  {
    path: PATHS.yard.globalAllocationRules.url,
    component: GlobalAllocationRules,
  },
  {
    path: PATHS.config.berths.url,
    component: Berths,
    requiredPermission: PATHS.config.berths.permission,
  },
  {
    path: PATHS.config.piers.url,
    component: isNewYardEnabled ? PiersPage : Piers,
    requiredPermission: PATHS.config.piers.permission,
  },
  {
    path: `${PATHS.config.piers.url}/new`,
    component: PierFormPage,
    requiredPermission: PATHS.config.piers.permission,
  },
  {
    path: `${PATHS.config.piers.url}/:id`,
    component: PierFormPage,
    requiredPermission: PATHS.config.piers.permission,
  },
  {
    path: PATHS.config.railTracks.url,
    component: RailTracksPage,
  },
  {
    path: PATHS.operators.operatorContainerTurnoversList.url,
    component: OperatorContainerTurnoversList,
  },
  {
    path: `${PATHS.operators.operatorContainerTurnoversList.url}/:containerTurnoverId`,
    component: UpdateContainerByOperator,
  },
  {
    path: PATHS.generalCargo.inventory.url,
    component: GeneralCargoInventory,
  },
  {
    path: PATHS.generalCargo.cargoAreas.url,
    component: GeneralCargoAreas,
  },
  {
    path: PATHS.masterData.commoditiesAndPackaging.url,
    component: CommoditiesAndPackaging,
    requiredPermission: PATHS.masterData.commoditiesAndPackaging.permission,
    hidden: !hasGeneralCargo,
  },
  {
    path: `${PATHS.masterData.commoditiesAndPackaging.url}/${PATHS.masterData.commoditiesAndPackaging.commodity.url}/:catalogue/:parent/new`,
    component: CommodityFormPage,
    requiredPermission: PATHS.masterData.commoditiesAndPackaging.commodity.permission,
    hidden: !hasGeneralCargo,
  },
  {
    path: `${PATHS.masterData.commoditiesAndPackaging.url}/${PATHS.masterData.commoditiesAndPackaging.commodity.url}/:catalogue/:parent/:id`,
    component: CommodityFormPage,
    requiredPermission: PATHS.masterData.commoditiesAndPackaging.commodity.permission,
    hidden: !hasGeneralCargo,
  },
  {
    path: PATHS.masterData.allocationRuleTemplates.url,
    component: isNewYardEnabled ? AllocationRulesTemplatePage : OldAllocationRuleTemplatesPage,
    hidden: isNewYardEnabled ? false : skipYardPlanning,
  },
  {
    path: `${PATHS.masterData.allocationRuleTemplates.url}/new`,
    component: AllocationRuleTemplateFormView,
    hidden: isNewYardEnabled ? false : skipYardPlanning,
  },
  {
    path: `${PATHS.masterData.allocationRuleTemplates.url}/:id`,
    component: AllocationRuleTemplateFormView,
    hidden: isNewYardEnabled ? false : skipYardPlanning,
  },
  {
    path: PATHS.masterData.weightClasses.url,
    component: WeightClassesPage,
    requiredPermission: PATHS.masterData.weightClasses.permission,
  },
  {
    path: PATHS.masterData.damageCatalogue.url,
    component: DamageCatalogue,
    requiredPermission: PATHS.masterData.damageCatalogue.permission,
    hidden: !hasDamageCatalogue,
  },
  {
    path: PATHS.masterData.dangerousGoodsSettings.url,
    component: DGSettingsPage,
  },
  {
    path: PATHS.masterData.containerLengthBayMappings.url,
    component: ContainerLengthBayMappingsPage,
    requiredPermission: PATHS.masterData.containerLengthBayMappings.permission,
    requiredFeatureFlag: { name: 'new-yard', enable: true },
  },
  {
    path: PATHS.masterData.vesselServices.url,
    component: VesselServicePage,
    requiredPermission: PATHS.masterData.vesselServices.permission,
  },
  {
    path: PATHS.masterData.holdTypes.url,
    component: HoldTypesListWrapper,
    requiredPermission: PATHS.masterData.holdTypes.permission,
  },
  {
    path: PATHS.masterData.holdTypes.add.url,
    component: AddHoldTypeWrapper,
    requiredPermission: PATHS.masterData.holdTypes.add.permission,
  },
  {
    path: PATHS.masterData.holdTypes.edit.url,
    component: AddHoldTypeWrapper,
    requiredPermission: PATHS.masterData.holdTypes.edit.permission,
  },
  {
    path: PATHS.reportsV2.url,
    component: ContainerJourneyReportPage,
  },
  {
    path: PATHS.reportsV2.containerJourneys.url,
    component: ContainersReport,
  },
]
